import React, { useEffect, useState } from "react";
import { useMoralisQuery, useMoralis } from "react-moralis";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";
import ConnectWallet from "./ConnectWallet";

import { Button } from "antd";
import NFT from "images/image.jpg";
import Matic from "images/matic.png";
import { Helmet } from "react-helmet";
// import MetaTags from "react-meta-tags";

function NFTDetails(props) {
  const { authenticate, isAuthenticated } = useMoralis();
  const { Moralis } = useMoralis();
  const { marketAddress, contractABI, walletAddress } = useMoralisDapp();
  const contractABIJson = JSON.parse(contractABI);
  const [nftId, setNftId] = useState(0);
  const [nftName, setNftName] = useState(0);
  const [showWallet, setShowWallet] = useState(false);
  const purchaseItemFunction = "redeem";
  useEffect(() => {
    setNftId(props.history.location.state.id);
    setNftName(props.history.location.state.name);
  }, []);
  const queryMarketItems = useMoralisQuery("NftCreated");
  const fetchMarketItems = JSON.parse(
    JSON.stringify(queryMarketItems.data, [
      "objectId",
      "createdAt",
      "copies",
      "remainingCopies",
      "price",
      "metadata",
      "nftOwner",
      "nftId",
      "signature",
      "nonce",
      "name",
      "description",
      "image",
    ])
  ).filter((item) => item.nftId === nftId);
  const buyItem = (id) => {
    const result = fetchMarketItems?.find((e) => e.nftId === id);
    return result;
  };
  async function BuyNFT(id) {
    if (!isAuthenticated) {
      setShowWallet(true);
    } else {
      const createdItems = buyItem(id);
      console.log("buy", createdItems);
      const voucher_values = [];
      voucher_values.push(createdItems.nftId);
      voucher_values.push(createdItems.price);
      voucher_values.push(createdItems.copies);
      voucher_values.push(createdItems.nftOwner);
      voucher_values.push(createdItems.signature);
      console.log(voucher_values);
      purchase(
        voucher_values,
        walletAddress,
        createdItems.nonce,
        createdItems.price,
        id
      );
    }
  }
  async function purchase(voucher_values, buyer, nonce, price, id) {
    const ops = {
      contractAddress: marketAddress,
      functionName: purchaseItemFunction,
      abi: contractABIJson,
      params: {
        voucher: voucher_values,
        buyer: buyer,
        nonce: nonce,
        copies: 1,
      },
      msgValue: price,
    };
    try {
      const res = await Moralis.executeFunction(ops);
      console.log("result", res);
      const createdItems = buyItem(id);
      const remainingCopies = createdItems.remainingCopies - 1;
      const nonce = createdItems.nonce + 1;
      const queryMarketItems = Moralis.Object.extend("NftCreated");
      const query = new Moralis.Query(queryMarketItems);
      query.equalTo("nftId", 1);
      const setQuery = await query.first();
      setQuery.set("remainingCopies", remainingCopies);
      setQuery.set("nonce", nonce);
      setQuery.save();
      const nftBuy = Moralis.Object.extend("NftBuy");
      const boughtItem = new nftBuy();
      // const buyQuery = new Moralis.Query(nftBuy);
      // const buyItem = new buyQuery();
      boughtItem.set("nftId", createdItems.nftId);
      boughtItem.set("nonce", createdItems.nonce);
      boughtItem.set("buyer", createdItems.nftOwner);
      boughtItem.set("copies", 1);
      boughtItem.save();
    } catch (e) {
      console.log(e);
    }
  }
  const Web3 = require("web3");
  const web3 = new Web3(
    Web3.givenProvider || "ws://some.local-or-remote.node:8546"
  );

  return (
    <div class="container">
      <Helmet>
        <title>Web3 Texas</title>
        <meta
          name="description"
          content="The Longhorn NFT drop is a very special drop that will fuel the global growth of Web3 Texas. You can buy this NFT with your crypto wallet or credit card."
        ></meta>
        <meta
          name="keywords"
          content="NFT drop, Longhorn NFT drop, Token, ERC 721, Minting, IPFS, polygon, Buy with wallet, Web3 Texas, Web3 Earth"
        ></meta>
      </Helmet>
      {showWallet && <ConnectWallet />}
      {fetchMarketItems?.map((item, index) => (
        <div class="row mt-5">
          <div class="col-md-4 ">
            <div class="mb-4">
              <img src={item.image} class="a-images" alt="NFTImage" />
            </div>
            <div className="mt-5">
              <h3 class="text-white">DETAILS</h3>
              <div class="text-white des-p mt-3">
                <p>Token Standard : ERC 1155</p>
                <p class="fw-light">Lazy Minting</p>
                <p class="fw-light">
                  View on{" "}
                  <a
                    href="#"
                    className="fw-bold text-decoration-none text-white"
                  >
                    POLYGONSCAN <i class="bi bi-box-arrow-up-right mx-2"></i>
                  </a>
                </p>
                <p class="fw-light">
                  View{" "}
                  <a
                    href={item.metadata}
                    className="fw-bold text-decoration-none text-white"
                  >
                    IPFS <i class="bi bi-box-arrow-up-right mx-2"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-8 ">
            <div class="text-white mb-5">
              <h3 className="text-white mb-3">{item.name}</h3>
              <p>
                {item.remainingCopies} / {item.copies} remaining
              </p>
              <h3 class="mt-4 text-white d-flex align-items-center ">
                {/* <img src="images/webpage/matic.png" class="" alt="matic"/> */}
                <img src={Matic} className="pe-3" alt="Matic" />{" "}
                {web3.utils.fromWei(String(fetchMarketItems[0].price), "ether")}{" "}
                Matic
              </h3>
              <h3 class="mt-5 mb-4 text-white">DESCRIPTION</h3>
              <p>{item.description}</p>
            </div>
            {/* <div class="navbar-nav ms-auto">
        <a class="btn btn-primary a-bg border-0 rounded-pill line"
           href="mailto:shockerzelectricals@gmail.com">BUY WITH WALLET</a>
     </div> */}
            <Button
              className="primary-button buy-button text-white d-btn b-w"
              size="large"
              onClick={() => BuyNFT(nftId)}
            >
              BUY WITH WALLET
            </Button>
            <h3 className="text-white my-2 text-center wallet-s">OR</h3>
            <Button
              className="border-button buy-button text-white d-btn b-w p-1 border-0"
              size="large"
            >
              BUY WITH CREDIT CARD
            </Button>
            {/*
         <Button
           className="primary-button buy-button text-white w-100"
           size="large"
           onClick={()=> claim()}
         >
           CLAIM
         </Button> */}
            {/* <div class="navbar-nav me-auto credit line my-4">
        <a class="btn btn-primary  border-0 " href="mailto:shockerzelectricals@gmail.com">BUY WITH CREDIT
           CARD</a>
     </div> */}
            <p class="text-white mt-5">
              <i class="bi bi-arrow-clockwise mx-2"></i> Refresh{" "}
              <a className="fw-bold text-decoration-none text-white">
                {" "}
                METADATA
              </a>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default NFTDetails;
